import Color from '../Color.mjs'
import superMeta from '../_ALG/metaAlgNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_YELLOW,
    algType: 'SUMMARY',
    name: '用户场景',
    ownerIdProp: 'bdId',
    ownerTextProp: 'bdName',
    ownerType: 'BD',
    type: 'BDSUMMARY',
}
